/**
 * NetworkLedger — `/network/ledger` route.
 *
 * Body is the hand-built design from `network-ledger.html`. Navbar +
 * Footer + App.js routing all unchanged.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { NetworkLedgerHero } from "../components/NetworkLedgerHero";

export default function NetworkLedger() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="network-ledger-page">
      <Helmet>
        <title>T-REX Ledger : One golden record, every chain.</title>
      </Helmet>
      <Navbar />
      <div aria-hidden="true" style={{ height: 64 }} />
      <NetworkLedgerHero />
      <Footer />
    </main>
  );
}
